{
  "states": {
    "loading": "Загрузка...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "San Francisco"
  },
  "conditions": {
    "Clear": "Ясно",
    "Clouds": "Облачно",
    "Rain": "Дождь",
    "Drizzle": "Морось",
    "Thunderstorm": "Гроза",
    "Snow": "Снег",
    "Mist": "Дымка",
    "Smoke": "Смог",
    "Haze": "Мгла",
    "Dust": "Пыль",
    "Fog": "Туман",
    "Sand": "Песок",
    "Ash": "Пепел",
    "Squall": "Шквал",
    "Tornado": "Торнадо"
  },
  "modal": {
    "defaultTitle": "Погода",
    "subtitle": "Текущие условия",
    "showFahrenheit_aria": "Показать по Фаренгейту",
    "showCelsius_aria": "Показать по Цельсию",
    "switchToCelsius_title": "Переключить на °C",
    "switchToFahrenheit_title": "Переключить на °F",
    "feelsLike": "Ощущается как {{temp}}°{{unit}}",
    "humidityWind": "Влажность {{humidity}}% · Ветер {{wind}}",
    "windSpeed": "{{speed}} mph",
    "hourlyNow": "Сейчас",
    "hourlyOffset": "{{hours}}ч",
    "hourlyStrip_aria": "Почасовая температура",
    "hourlyLocked": "Почасовой прогноз — возможность Pro.",
    "statsLocked": "Детали погоды — возможность Pro.",
    "stats": {
      "sunrise": "Восход",
      "sunset": "Закат",
      "feels": "Ощущается",
      "humidity": "Влажность",
      "wind": "Ветер",
      "rain": "Дождь"
    },
    "rainInches": "{{value}} дюйм",
    "forecastTitle": "Прогноз на 5 дней",
    "forecastLoading": "Загрузка прогноза…",
    "forecastUnavailable": "Прогноз недоступен",
    "forecastLocked": "Прогноз на 5 дней — возможность Pro.",
    "forecastRow_aria": "Прогноз на пять дней",
    "proHeadline": "Полный прогноз — часть Pro.",
    "proFeatures": "Почасовой · Подробные условия · Прогноз на 5 дней."
  }
}
